angular
    .module('empower.lodgeClaim')
    .constant('lodgeClaimWording', {
        LODGE_CLAIM_SUCCESS: 'Your claim has been submitted. A member of our team will contact you shortly to help you with your needs.<br/>If you need to speak to us you can call us toll free on 1800 469 931.',
        LODGE_CLAIM_FAILED: 'Unexpected errors occurred during uploading!',
        // BEGIN for form validation
        VALIDATION_POLICY_REQUIRED: 'Please select one policy.',
        VALIDATION_WORKER_NAME_REQUIRED: 'Please insert Worker Name.',
        VALIDATION_INVALID_WORKER_NAME: 'Please insert a valid Worker Name. The only allowed special characters are apostrophe (\') and dash (-).',
        VALIDATION_ADDRESS_REQUIRED: 'Please insert Address.',
        VALIDATION_DOB_REQUIRED: 'Please insert Date Of Birth.',
        VALIDATION_INVALID_DOB: 'Formatting Error: Please use the calendar to select your Date of Birth',
        VALIDATION_PHONE_REQUIRED: 'Please insert valid Phone Number.',
        VALIDATION_INVALID_PHONE: 'Please insert a valid Phone Number.',
        VALIDATION_FILE_REQUIRED: 'Worker claim form is mandatory to lodge a claim, please attach.',
        VALIDATION_CLAIM_FORM_REQUIRED: 'The Worker Claim Form is a mandatory requirement for claim lodgement. Please attach in order to proceed.',
        VALIDATION_CLAIM_FORM_EXIST: 'A claim form has already been attached. You will need to remove it to replace it with an updated form.',
        // END for form validation
        WORKER_CLAIM_FORM: 'WORKER_CLAIM_FORM',
        ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT'
    });